'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./cart/cart'));
    processInclude(require('./cart/crc'));
    processInclude(require('./libs/webGLViewer'));
    processInclude(require('./components/productPersonalization'));
});
